
/**
 * Custom component for WV Steak House steak section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <WVSteakHouseSteakSection> adds customizations for the WV Steak House steak menu section.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <WVSteakHouseSteakSection>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <WVSteakHouseSteakSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  name: 'WvSteakHouseSteakSection',
  components: {WvSteakHouseDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    isPrimeRibsSection() {
      return /(^|\s)prime ribs?(\s|$)/i.test(this.section.ms_title);
    }
  }
})
